import classNames from 'classnames'
import { forwardRef, type InputHTMLAttributes } from 'react'

export interface SliderProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?:     string
  showValue?: boolean
  formatValue?: (value: number) => string
}

export const Slider = forwardRef<HTMLInputElement, SliderProps>(
  function Slider({ label, showValue, formatValue, value, className, id, ...props }, ref) {
    const sliderId  = id ?? label?.toLowerCase().replace(/\s+/g, '-')
    const numValue  = typeof value === 'number' ? value : Number(value ?? 0)
    const displayed = formatValue ? formatValue(numValue) : String(numValue)

    return (
      <div className={classNames('flex flex-col gap-2 w-full', className)}>
        {(label || showValue) && (
          <div className="flex items-center justify-between">
            {label && (
              <label htmlFor={sliderId} className="font-body text-[13px] text-text-muted">
                {label}
              </label>
            )}
            {showValue && (
              <span className="font-body text-[13px] font-semibold text-text-main">
                {displayed}
              </span>
            )}
          </div>
        )}
        <input
          ref={ref}
          id={sliderId}
          type="range"
          value={value}
          className={classNames(
            'w-full h-1.5 rounded-full appearance-none cursor-pointer',
            'bg-surface-alt',
            '[&::-webkit-slider-thumb]:appearance-none',
            '[&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:h-5',
            '[&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-secondary',
            '[&::-webkit-slider-thumb]:shadow-sm',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary/40',
          )}
          {...props}
        />
      </div>
    )
  },
)

Slider.displayName = 'Slider'
